import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/UniPass.svg';
const _hoisted_1 = {
  class: "up-supported-by"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Supported by", -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "unipass-logo",
  src: _imports_0
}, null, -1);

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "UniPass", -1);

const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5);
}